import { IconButton } from '@mui/material';
import { RxCross2 } from 'react-icons/rx';
import { TickIcon } from '@/icons/Tick';

// tick and cross btns
const TickAndCrossbtn = ({ disabled, onClickTick, onClickCross }: any) => {
  return (
    <>
      <IconButton
        disabled={disabled}
        sx={{
          display: 'flex',
          padding: '16px',
          background: '#2469F3',
          width: '109px',
          height: '56px',
          borderRadius: '4px',
          // border: '1px solid #E6E6E6',
          ':hover': {
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.10)',
            background: '#2469F3'
          },
          '&:disabled': {
            background: 'rgba(36, 105, 243, 0.30)',
            color: 'white'
          }
        }}
        onClick={onClickTick}
        children={<TickIcon />}
      />
      <IconButton
        onClick={onClickCross}
        sx={{
          display: 'flex',
          padding: '16px',
          background: '#fff',
          width: '56px',
          height: '56px',
          borderRadius: '4px',
          border: '1px solid #E6E6E6',
          ':hover': {
            background: '#CC1F1F',
            color: '#fff',
            boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10), 0px -4px 8px 0px rgba(0, 0, 0, 0.05)'
          }
        }}
        className='cross-btn'
      >
        <RxCross2 style={{ width: '24px', height: '24px' }} />
      </IconButton>
    </>
  );
};

export default TickAndCrossbtn;
